import React from "react";
import "./index.scss";
import { Box, Button, Illustration, Text, UnorderedList } from "@mbank-design/design-system/components";
import { IllustrationSize } from "@mbank-design/design-system/enums";
import * as Illustrations from "@mbank-design/design-system/illustrations";
import CustomIllustration from "../../../assets/images/karta_prduktu256x256.jpg"
import "./index.scss";
const PromoBannerForAll = ({ literals, urlToContactSection, handleContactModal }) => {
  if (
    !literals.promo_label_new_car_title ||
    !literals.promo_label_new_car_subtitle ||
    !literals.promo_label_new_car_illustration ||
    !literals.promo_label_afterlease_car_title ||
    !literals.promo_label_afterlease_car_subtitle ||
    !literals.promo_label_afterlease_car_illustration
  ) {
    return;
  }
  const handleButtonClick = () => {
    setLocalStorageContactPreference();
    handleContactModal(urlToContactSection);
  };

  const setLocalStorageContactPreference = () => {
    localStorage.setItem("onlyOffer", true);
    // LinkedIn Insight Tag
    // setVehicleOfferButtonInsightTag();
  };

  const convertColorLiteral = (literal) => {
    literal = literal.replaceAll("[SPAN]", "<span>");
    literal = literal.replaceAll("[/SPAN]", "</span>");

    literal = literal.replaceAll("[SPAN", "<span");
    literal = literal.replaceAll('"]', '">');
    return literal;
  };
  return (
    <div className="promo-banner-for-all">
      <div className="promo-banner-for-all__content">
        <div className="promo-banner-for-all__left">
          <div className="promo-banner-for-all__title">
          <Box background={"#ff8600"} padding={8} borderRadius={"small"} width={"fit-content"}>
            <Text as={"p"} color={"white30"}>
              promocja
            </Text>
          </Box>
            {(
              <Text
                as={"h1"}
                marginTop={6}
                marginBottom={6}
                fontSize={[32,36]}
              >
                kieruj się zyskiem
              </Text>
            )}
          </div>
          <div className="promo-banner-for-all__subtitle">
          spłacaj raty za to auto z konta firmowego
          <br/>    
          w mBanku i zyskaj <strong>2000 zł</strong>
          </div>
          {/* <div className="promo-banner-for-all__button">
            <Button buttonType="primary" onClick={handleButtonClick}>
              zapytaj o ofertę
            </Button>
          </div> */}
          </div>
        <div className="promo-banner-for-all__right">
          <img src={CustomIllustration} alt="Promo Banner" />
        </div>
      </div>
      <div>
        <Text as={"body"} marginTop={12} fontSize={12}>
        Szczegóły promocji w  <a href="https://mauto.pl/static/media/Regulamin-promocji-Taniej-z-mBankiem-3-edycja.d04296200dc690a8a63e.pdf" target="_blank" rel="noreferrer">regulaminie.</a>
        </Text>
      </div>
    </div>
  );
};

export default PromoBannerForAll;
